import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/53/thumb-landscape.webp"

const Post53 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Louis Vuitton／アンプラント オンザゴーPM／25 x19 x10cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            雨上がりの街に、初夏のやわらかな陽ざしが差し込む6月上旬。<br></br>
            梅雨の気配を感じつつも、空気にはほんのりと夏の気配が漂い、気温や湿度が徐々に上昇するこの時季。ファッションにも涼やかさや抜け感が求められます。<br></br><br></br>
            そんな今、シンプルな夏の装いをさりげなく格上げしてくれるのが「ルイ・ヴィトン（Louis Vuitton）」のバッグです。<br></br><br></br>
            多くの女性たちが憧れるルイ・ヴィトン。その魅力とは何なのか、そしてラクサスを通じてどのようにその魅力を体験できるのか、詳しくお届けします。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">            
      <div id ="sec1" className="text-max-width">
        <h2><span className="text-border-bottom text-font-bolder" style={{color: "#696969", borderColor: "#696969"}}>〜 ルイ・ヴィトンとは？ 〜</span></h2>
      </div>
      <p className="text-max-width">ルイ・ヴィトンとは、トランク職人として腕を磨いてきた創業者ルイ・ヴィトンによるファッションブランドです。14歳で家を飛び出し、トランク職人として20年近く腕を磨き、1854年にパリのカプシーヌ通りに世界初の旅行カバン専門店を開店させます。これが世界的ファッションブランド、ルイ・ヴィトンの歴史の始まりです。</p>
      <p className="text-max-width">当時は主流だった丸い蓋を平らにしたり、革製だった素材を防水の軽いコットン素材にしたり、これまでとは異なる視点からデザインすることで世間から高く評価されました。</p>
      <p className="text-max-width">1888年には息子のジョルジュ・ヴィトンに経営を引き継ぎ、模倣品防止を目的とした「ダミエ」を考案します。現代の定番ライン「モノグラム」が誕生したのは、ダミエが誕生してしばらくしてから、1896年のことです。</p>
      <p className="text-max-width">
        その後も成長を続け、ルイヴィトンは世界のトップアパレルブランドとなりました。<br></br>
        最近は、鮮やかなカラーリングのモデルも増え、トレンドとの親和性がぐっと高まっています。
      </p>
      <div id ="sec2" className="text-max-width">
        <h2><span className="text-border-bottom text-font-bolder" style={{color: "#696969", borderColor: "#696969"}}>〜 ルイ・ヴィトンの魅力 〜</span></h2>
      </div>
      <p className="text-max-width">ファッション好きなら誰もが一度は憧れるルイ・ヴィトンのバッグ。1854年に誕生して以来、旅のエスプリを感じさせるラグジュアリーブランドとして不動の地位を築いてきました。中でもモノグラムやダミエは、時代を超えて愛され続けるクラシックなアイコンです。</p>
      <p className="text-max-width">魅力はその洗練されたデザインだけでなく、職人の手による確かな品質。デイリーユースにも耐えるタフさと、年月を経ても色褪せないエレガンスを兼ね備えているんです。</p>
      <p className="text-max-width">最近では、サステナビリティを意識したリサイクル素材やヴィンテージラインも人気です。ひとつ持つだけでコーディネートが洗練され、背筋がすっと伸びる。そんな特別な存在感が、ルイ・ヴィトンの真の魅力なのかもしれません。</p>
      <div id ="sec3" className="text-max-width">
        <h1>憧れのバッグをもっと身近に-ラクサスのシェアリングサービス</h1>
      </div>
      <p className="text-max-width">「高価なルイ・ヴィトンのバッグ、欲しいけれどなかなか手が届かない…」 「失敗したくない」「流行りのバッグが欲しいけど飽きて使わなくなったらどうしよう…」そんなお悩みを持つ方にぴったりなのが、私たちラクサスのシェアリングサービスです。</p>
      <p className="text-max-width">ラクサスでは、月額制でブランドバッグを自由に使える仕組みを提供しています。エルメス・ヴィトン・シャネルなど60ブランドのバッグが揃っており、気分やシーンに合わせてお好きなバッグを選ぶことが可能です。</p>
      <p className="text-max-width">バッグはすべて本物保証付きで、専門スタッフによる品質管理を徹底しているため、安心してご利用いただけます。しかも、使い放題で交換回数に制限なし。気になるバッグを思う存分楽しめる、それがラクサスの魅力です。</p>
      <div className="text-max-width">
        <h2><span className="text-border-bottom text-font-bolder">実際に使ってみたユーザーの声</span></h2> 
      </div>
      <div className="text-img-cloumn">
        <figure><StaticImage src="../../images/posts/53/1.png"/></figure>
        <p>「昔からルイ・ヴィトンに憧れていましたが、なかなか購入には踏み切れず…。ラクサスで初めて『オンザゴー』を使ってみて、やっぱり素敵だなと実感しました。お出かけが楽しみになりました！」（30代女性・会社員）</p>
      </div>
      <div className="text-img-cloumn">
        <figure><StaticImage src="../../images/posts/53/2.png"/></figure>
        <p>「子育て中で、普段は実用性重視のバッグばかり。でも、ラクサスなら気軽にルイ・ヴィトンを楽しめるので、ちょっと特別な日には『ネヴァーフル』を選んでテンションを上げています」（40代女性・主婦）</p>
      </div>
      <div id ="sec4" className="text-max-width">
        <h1>夏におすすめ！ルイ・ヴィトンの人気バッグ5選</h1>
      </div>
      <p className="text-max-width" style={{marginBottom: "8rem"}}>
        ラクサスで実際に人気が高く、特に夏におすすめのルイ・ヴィトンのバッグをご紹介します。軽やかさ、清涼感、機能性など、この季節ならではの魅力が詰まったモデルばかりです。<br></br>
        夏のファッションにぴったりのバッグを選ぶポイントとして、まず重要なのは軽さと持ちやすさです。暑い季節には、軽やかでストレスなく持ち歩けるバッグが理想的。また、涼しげなカラーやキャンバス素材も魅力のひとつ。例えば、アイボリーやパステルカラーは夏らしい印象を与えてくれます。さらに、機能性にも注目。収納力があり、普段使いしやすいデザインなら、旅行やお出かけにも活躍します。そんなポイントを踏まえ、ラクサスで人気のルイ・ヴィトンの人気バッグをご紹介します。
      </p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/3.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/4.jpg"/>
        </figure>
      </div>
      <span className="text-center">Louis Vuitton／ダミエ ネヴァーフルMM／32 x 29 x 17cm</span> 
      <p className="text-max-width">広々とした開口部と抜群の収納力が魅力の「ネヴァーフルMM」。飽きのこないクラシックなデザインは、幅広い年齢層に愛され、どんなファッションにも合わせやすい万能バッグです。</p>
      <p className="text-max-width" style={{marginBottom: "8rem"}}><span className="text-border-bottom">おすすめポイント</span>：今年らしいブラン系のシンプルなワンピースコーデや Tシャツ×デニムといったラフな装いも、これひとつで一気に格上げ。週末の買い物や習い事、お子様との公園遊びなど、荷物が多くなりがちなシーンで活躍する、定番中の定番です。</p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/5.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/6.jpg"/>
        </figure>
      </div>
      <span className="text-center">Louis Vuitton／アンプラント ネオアルマBB／23 x18 x12cm</span> 
      <p className="text-max-width">フェミニンな丸みを帯びたフォルムが上品な「ネオアルマBB」。エンボス加工されたモノグラム・アンプラントレザーのアイボリーカラーは、優しく洗練された印象を与えます。コンパクトながらもマチがしっかりあり、スマートフォンやミニウォレット、リップなどの必需品を収納可能。</p>
      <p className="text-max-width" style={{marginBottom: "8rem"}}><span className="text-border-bottom">おすすめポイント</span>：ショルダーストラップ付きで、両手が自由に使える実用性の高さもこのバッグの魅力です。夏のワントーンコーデに合わせれば、大人の雰囲気を演出できます。ショッピングやカフェ巡りにぴったりです。</p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/7.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/8.jpg"/>
        </figure>
      </div>
      <span className="text-center">Louis Vuitton／LVブロデリー ナノノエ／13 x15 x10cm</span> 
      <p className="text-max-width">「ナノノエ」の愛らしいミニサイズに、刺繍のようなLVロゴが目を引く「LVブロデリー」。鮮やかなイエローは、コーディネートの差し色として抜群の存在感を放ちます。スマートフォンとカードケース程度の最小限の荷物を収納し、身軽に出かけたい時に最適です。</p>
      <p className="text-max-width" style={{marginBottom: "8rem"}}><span className="text-border-bottom">おすすめポイント</span>：夏らしいビタミンカラー。フェスやイベント、テーマパークでの一日。ペールカラーのスタイルに遊び心を加えたい時など、ファッションのアクセントとして楽しめます。</p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/9.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/10.jpg"/>
        </figure>
      </div>
      <span className="text-center">Louis Vuitton／モノグラムリバース カンヌ／15 x16 x14cm</span> 
      <p className="text-max-width">レトロなバニティケースから着想を得た「カンヌ」。モノグラム・リバース キャンバスの配色がモダンな印象を与え、コーディネートを格上げします。コンパクトながらも収納部が分かれており、整理しやすいのが特徴。トップハンドルで上品に、付属のストラップでクロスボディにすればカジュアルにも持てます。</p>
      <p className="text-max-width" style={{marginBottom: "8rem"}}><span className="text-border-bottom">おすすめポイント</span>：ミニサイズながらしっかり収納できるのも魅力。友人とのランチやカフェ巡り、ちょっとしたお出かけ、旅行先でのセカンドバッグなど、おしゃれを楽しみたい日に最適です。</p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/11.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/53/12.jpg"/>
        </figure>
      </div>
      <span className="text-center">Louis Vuitton／アンプラント オンザゴーPM／25 x19 x10cm</span> 
      <p className="text-max-width">近年登場した注目のトートバッグ。ジャイアントモノグラムが目を引き、夏のコーデの主役に。A4サイズの書類も収まる収納力と、トップハンドル、ショルダーストラップの2WAY仕様で、ビジネスからデイリーまで幅広く活躍する「オンザゴーPM」。アンプラントレザーのブラックとベージュのバイカラーは、シックで上品な印象を与えます。</p>
      <p className="text-max-width" style={{marginBottom: "8rem"}}><span className="text-border-bottom">おすすめポイント</span>：内部には複数のポケットがあり、機能性も抜群。通勤バッグとしてはもちろん、お仕事帰りのショッピングや、少し荷物が多いけれどきちんとした印象を与えたい休日のお出かけにもおすすめです。</p>
      <div id ="sec5" className="text-max-width">
        <h1>最後に：あなたも今日から「ルイ・ヴィトン’’デビュー’’」</h1>
      </div>
      <p className="text-max-width">
        ルイ・ヴィトンのバッグには、「今日はカジュアルに」「週末は上品に」といった、その日の気分に合わせたスタイルを叶える力があります。<br></br>
        所有ではなく“シェア”することで、もっと自由にファッションを楽しむことができます。
      </p> 
      <p className="text-max-width">また、環境にもやさしいサステナブルな選択です。使われないまま眠るバッグを減らし、ひとつのバッグが多くの人の手に渡って活躍する。</p> 
      <p className="text-max-width">そんな<span className="text-font-bolder">新しい価値の循環</span>が、ここにあります。</p> 
      <p className="text-max-width">
        「自分をもっと好きになる」<br></br>
        そんな体験が、ラクサスなら気軽に、毎月できます。
      </p> 
      <p className="text-max-width">
        ブランドバッグは、気分を高め、自信をくれるパートナー。<br></br>
        今の自分に似合うバッグを探す時間も、使っている間の特別な気持ちも、きっとあなたの毎日を豊かにしてくれるはずです。
      </p> 
      <p className="text-max-width">この夏、あなたも<span className="text-font-bolder">“ルイ・ヴィトンのある暮らし”</span>を始めてみませんか？</p> 
      <div className="border"></div>        
      <p className="text-max-width">📱憧れを日常に──ラクサスでルイ・ヴィトンを体験しよう！</p>                           
      <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
        ルイ・ヴィトンのバッグはこちら
      </Link>  
    </section>
    </div>
  </div>
</Layout>
)}

export default Post53

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 53}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
